import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _convertOrderBy, _mapTencentDocMimeTyp;
import { getUid } from '@tencent/docs-login';
import { MimeType, mimeTypeToExtMap } from '@tencent/docs-mime-types';
import axios from 'axios';
import { camelizeKeys } from 'humps';
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { MY_DOC_FOLDER_ID, OrderBy, RECENT_FOLDER_ID, SHARED_FOLDER_ID, SpecialFolderId, SpecialSource, VAGUE_ROOT_ID } from "../common/list-query";
import { requestV1Cgi, RetCode } from "../data-source/network-request";
import { COLLABORATION_SPACE_KIND } from "../model/collaboration-space";
import { DEFAULT_CREATOR_DOMAIN, DEFAULT_DOMAIN_ID, DocPolicy, DocSource, DocStatus, DRIVE_FILE_KIND, DriveFileType } from "../model/drive-file";
import { DRIVE_FOLDER_KIND, FOLDER_ATTRIBUTE } from "../model/drive-folder";
import { TencentDocExt } from "../model/file-node";
import { UserRole } from "../model/permission";
import { SHORT_CUT_KIND } from "../model/shortcut";
import { UNKNOWN_USER_NICK } from "../model/user";
export function getFileList(params) {
  return new FileListRequest(params).send();
}
export var FileListRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(FileListRequest, _DriveRequest);
  var _super = _createSuper(FileListRequest);
  function FileListRequest() {
    var _this;
    _classCallCheck(this, FileListRequest);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "url", void 0);
    _defineProperty(_assertThisInitialized(_this), "data", void 0);
    _defineProperty(_assertThisInitialized(_this), "uid", getUid());
    _defineProperty(_assertThisInitialized(_this), "isShared", false);
    _defineProperty(_assertThisInitialized(_this), "specialIdMap", {});
    _defineProperty(_assertThisInitialized(_this), "sharedFolderIdMap", {});
    return _this;
  }
  _createClass(FileListRequest, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
        var prefetchInfo, _yield$prefetchInfo$d, status, response, retcode;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              prefetchInfo = this.getPrefetchInfo(); // 目前仅在列表页首屏预拉取时，会使用该数据
              if (!prefetchInfo) {
                _context.next = 14;
                break;
              }
              _context.next = 4;
              return prefetchInfo.data;
            case 4:
              _yield$prefetchInfo$d = _context.sent;
              status = _yield$prefetchInfo$d.status;
              response = _yield$prefetchInfo$d.response;
              if (!(status === 200)) {
                _context.next = 14;
                break;
              }
              retcode = response === null || response === void 0 ? void 0 : response.retcode; // FIXME: 耦合了 desktop/src/core/user/user-service.ts 对 retcode 的处理机制。
              // 1、因为 desktop 监听通过 axios 发起的请求并对其中特殊 retcode 做了处理。
              // 2、又因为预拉取 doclist 不是使用 axios，所以需要 mock 一次假的 axios 请求。
              if (!retcode) {
                _context.next = 12;
                break;
              }
              _context.next = 12;
              return this.mockAxiosAuthenticationError(retcode);
            case 12:
              console.log('usePrefetchFileList, retcode:', retcode);
              return _context.abrupt("return", response);
            case 14:
              return _context.abrupt("return", requestV1Cgi(payload));
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function request(_x) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      var isSpecialFolder = Object.values(SpecialFolderId).includes(params.folderId);
      return {
        method: 'post',
        url: this.url = function () {
          if (!isSpecialFolder || params.folderId === SpecialFolderId.MyDoc) return '/api/list/file';
          if (params.folderId === SpecialFolderId.Recent) return '/api/list/recent';
          if (params.folderId === SpecialFolderId.Collection) return '/api/list/star';
          if (params.folderId === SpecialFolderId.Shared) return '/api/list/shared';
          throw new DriveApiError({
            name: 'FileListPayloadError',
            message: "Unsupported Folder Id ".concat(params.folderId),
            params: params,
            payload: null,
            response: null
          });
        }(),
        data: this.data = {
          parent_id: params.folderId === MY_DOC_FOLDER_ID ? VAGUE_ROOT_ID : params.folderId,
          offset: params.offset,
          count: params.limit,
          order_by: convertOrderBy[params.orders[0].by],
          descending: !params.orders[0].asc,
          filter: function () {
            var filter = {};
            if (params.mimeTypes && params.mimeTypes.length > 0) {
              var includeFolder = false;
              filter.include_ext = params.mimeTypes.flatMap(function (mimeType) {
                if (mimeType === MimeType.Folder) includeFolder = true;
                if (mapTencentDocMimeType2Ext[mimeType]) return mapTencentDocMimeType2Ext[mimeType];
                if (mimeTypeToExtMap[mimeType]) return mimeTypeToExtMap[mimeType];
                return [];
              });
              filter.include_folder = includeFolder;
            }
            if (params.source) {
              if (params.source === SpecialSource.Mine) filter.create_source = 1;
              if (params.source === SpecialSource.Others) filter.create_source = 2;
            }
            return filter;
          }(),
          xsrf: getXsrfToken()
        }
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      var _this2 = this,
        _ref,
        _result$parents_info;
      var retcode = response.retcode,
        msg = response.msg,
        result = response.result;
      if (retcode !== RetCode.Success) {
        throw new DriveApiError({
          name: 'FileListResultError',
          message: msg,
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
      this.isShared = this.params.folderId === SpecialFolderId.Shared;
      var user_space = result.user_space;
      if (user_space) {
        this.specialIdMap[user_space.mine] = MY_DOC_FOLDER_ID;
        this.specialIdMap[user_space.collaborate] = SHARED_FOLDER_ID;
      }
      return {
        items: result.files.map(function (item) {
          return _this2.getFileNode(item);
        }),
        hasNext: result.files.length === this.params.limit,
        currentFolderAttribute: result.parent_attribute ? camelizeKeys(result.parent_attribute) : {},
        currentPath: (_ref = (_result$parents_info = result.parents_info) === null || _result$parents_info === void 0 ? void 0 : _result$parents_info.reverse().map(function (item) {
          return _this2.getFileNode(item);
        })) !== null && _ref !== void 0 ? _ref : [],
        sharedFolderIdMap: this.sharedFolderIdMap
      };
    }

    // eslint-disable-next-line max-lines-per-function
  }, {
    key: "getFileNode",
    value: function getFileNode(item) {
      var _entry$access_time, _metadata$cos_info, _entry$is_starred, _entry$is_pin, _metadata$policy, _metadata$status, _metadata$thumbnail_u, _metadata$tencent_doc;
      var metadata = item.meta,
        mime_type = item.mime_type,
        entry = item.entry;
      var ownerVipInfo = JSON.parse(metadata.owner_vip_info || 'null');
      var id = metadata.file_id;
      if (this.isShared && metadata.link_file_id && metadata.link_file_id !== metadata.file_id) {
        id = metadata.link_file_id;
        this.sharedFolderIdMap[metadata.link_file_id] = metadata.file_id;
      }
      var fileNode = {
        kind: '',
        id: id,
        title: metadata.name,
        collaborationFlag: metadata.collaboration_flag,
        createTs: timestamp(metadata.create_time),
        creator: {
          uid: metadata.creator,
          nick: (entry === null || entry === void 0 ? void 0 : entry.creator_nick) || UNKNOWN_USER_NICK
        },
        docType: item.doc_type,
        iconUrl: metadata.icon_url,
        lastBrowseTs: timestamp((_entry$access_time = entry === null || entry === void 0 ? void 0 : entry.access_time) !== null && _entry$access_time !== void 0 ? _entry$access_time : metadata.access_time),
        lastDeleteTs: 0,
        lastModifyTs: timestamp(metadata.modify_time),
        lastModifier: {
          uid: metadata.modify_uid,
          nick: metadata.modifier_nick
        },
        mimeType: mime_type,
        owner: {
          uid: metadata.owner,
          nick: metadata.owner_nick,
          avatarFrameUrl: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.avatar_frame_url,
          expiredStatus: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.expired_status,
          vipLevel: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.vip_level,
          renewalStatus: ownerVipInfo === null || ownerVipInfo === void 0 ? void 0 : ownerVipInfo.renewal_status
        },
        originParentId: null,
        parentId: this.specialIdMap[metadata.file_parent_id] || metadata.file_parent_id,
        thirdAppId: metadata.source_appid,
        isOwnedByMe: item.is_owner
      };
      if (metadata.is_link) {
        Object.assign(fileNode, {
          kind: SHORT_CUT_KIND,
          targetId: metadata.link_file_id,
          url: metadata.tencent_doc_url,
          personalizeInfo: metadata.personalize_info ? {
            background: metadata.personalize_info.background,
            isExpire: metadata.personalize_info.is_expire,
            titleColor: metadata.personalize_info.title_color,
            mode: metadata.personalize_info.mode
          } : null
        });
        return fileNode;
      }
      if (metadata.is_folder && metadata.collaboration_flag === 1) {
        Object.assign(fileNode, {
          kind: COLLABORATION_SPACE_KIND,
          attribute: null,
          roleId: UserRole.Unauthorized,
          groupInfo: null
        });
        return fileNode;
      }
      if (metadata.is_folder) {
        Object.assign(fileNode, {
          kind: DRIVE_FOLDER_KIND,
          // 目前只能搜到自己的数据，因此文件夹都有权限
          attribute: FOLDER_ATTRIBUTE
        });
        return fileNode;
      }
      Object.assign(fileNode, {
        kind: DRIVE_FILE_KIND,
        ext: ((_metadata$cos_info = metadata.cos_info) === null || _metadata$cos_info === void 0 ? void 0 : _metadata$cos_info.drive_ext) || metadata.ext,
        clientId: metadata.client_id || null,
        // 空字符串 fallback 到 null
        creatorDomainId: DEFAULT_CREATOR_DOMAIN,
        domainId: DEFAULT_DOMAIN_ID,
        driveFileType: DriveFileType.CLOUD,
        groupChatKey: null,
        groupName: null,
        isCollected: (_entry$is_starred = entry === null || entry === void 0 ? void 0 : entry.is_starred) !== null && _entry$is_starred !== void 0 ? _entry$is_starred : false,
        isPinned: notSupportPin(this.params.folderId) ? null : (_entry$is_pin = entry === null || entry === void 0 ? void 0 : entry.is_pin) !== null && _entry$is_pin !== void 0 ? _entry$is_pin : false,
        lastCollectTs: timestamp((entry === null || entry === void 0 ? void 0 : entry.starred_time) || '0'),
        lastPinnedTs: timestamp((entry === null || entry === void 0 ? void 0 : entry.pin_time) || '0'),
        officialAuthInfo: metadata.official_auth_info_status === 1 ? metadata.official_auth_info : null,
        personalizeInfo: camelizeKeys(metadata.personalize_info),
        policy: (_metadata$policy = metadata.policy) !== null && _metadata$policy !== void 0 ? _metadata$policy : DocPolicy.Private,
        source: DocSource.Personal,
        status: (_metadata$status = metadata.status) !== null && _metadata$status !== void 0 ? _metadata$status : DocStatus.Normal,
        tenantId: metadata.tenant_id || null,
        // 空字符串 fallback 到 null
        thumbnailUrl: (_metadata$thumbnail_u = metadata.thumbnail_url) !== null && _metadata$thumbnail_u !== void 0 ? _metadata$thumbnail_u : '',
        url: (_metadata$tencent_doc = metadata.tencent_doc_url) !== null && _metadata$tencent_doc !== void 0 ? _metadata$tencent_doc : '',
        weDriveInfo: camelizeKeys(metadata.wedrive_info),
        size: Number(metadata.size) || 0,
        cosInfo: camelizeKeys(metadata.cos_info)
      });
      return fileNode;
    }
  }, {
    key: "getPrefetchInfo",
    value: function getPrefetchInfo() {
      var _prefetchFileListMap;
      var prefetchInfo = (_prefetchFileListMap = window.prefetchFileListMap) === null || _prefetchFileListMap === void 0 ? void 0 : _prefetchFileListMap.get(this.data.parent_id);

      // 预拉取结果已被使用时，返回 undefined。（请求参数（this.data）理论逻辑上不会为空）
      if (!prefetchInfo || prefetchInfo.used) return;

      // 校验请求的参数是否一致
      var valid = this.url === prefetchInfo.url && JSON.stringify(this.data) === JSON.stringify(prefetchInfo.payload);
      if (!valid) return;
      prefetchInfo.used = true; // 读取成功后，设为已读，不可再使用
      return prefetchInfo;
    }
  }, {
    key: "mockAxiosAuthenticationError",
    value: function () {
      var _mockAxiosAuthenticationError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(retcode) {
        var adapter;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              adapter = function adapter(config) {
                return Promise.resolve({
                  data: {
                    retcode: retcode
                  },
                  status: 200,
                  statusText: 'success',
                  headers: {},
                  config: config
                });
              };
              _context2.next = 3;
              return axios(_objectSpread(_objectSpread({}, this.payload), {}, {
                adapter: adapter
              }));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function mockAxiosAuthenticationError(_x2) {
        return _mockAxiosAuthenticationError.apply(this, arguments);
      }
      return mockAxiosAuthenticationError;
    }()
  }]);
  return FileListRequest;
}(DriveRequest);

/** https://git.woa.com/docx-online/docx-online/blob/e17ebb427b5fccdcd611b495aad1249eaa993272/backend/common/proto/api/list/list.proto#L222 */
var FileListOrderBy = /*#__PURE__*/function (FileListOrderBy) {
  FileListOrderBy[FileListOrderBy["ACCESS_TIME"] = 0] = "ACCESS_TIME";
  FileListOrderBy[FileListOrderBy["MODIFY_TIME"] = 1] = "MODIFY_TIME";
  FileListOrderBy[FileListOrderBy["NAME"] = 2] = "NAME";
  FileListOrderBy[FileListOrderBy["DELETE_TIME"] = 3] = "DELETE_TIME";
  FileListOrderBy[FileListOrderBy["WEIGHTS"] = 4] = "WEIGHTS";
  FileListOrderBy[FileListOrderBy["STARRED_TIME"] = 5] = "STARRED_TIME";
  FileListOrderBy[FileListOrderBy["CREATE_TIME"] = 6] = "CREATE_TIME";
  return FileListOrderBy;
}(FileListOrderBy || {});
var convertOrderBy = (_convertOrderBy = {}, _defineProperty(_convertOrderBy, OrderBy.ModifyTime, FileListOrderBy.MODIFY_TIME), _defineProperty(_convertOrderBy, OrderBy.AccessTime, FileListOrderBy.ACCESS_TIME), _defineProperty(_convertOrderBy, OrderBy.Name, FileListOrderBy.NAME), _defineProperty(_convertOrderBy, OrderBy.CreateTime, FileListOrderBy.CREATE_TIME), _convertOrderBy);
var mapTencentDocMimeType2Ext = (_mapTencentDocMimeTyp = {}, _defineProperty(_mapTencentDocMimeTyp, MimeType.Doc, TencentDocExt.TencentDoc), _defineProperty(_mapTencentDocMimeTyp, MimeType.Sheet, TencentDocExt.TencentSheet), _defineProperty(_mapTencentDocMimeTyp, MimeType.Slide, TencentDocExt.TencentSlide), _defineProperty(_mapTencentDocMimeTyp, MimeType.Form, TencentDocExt.TencentForm), _defineProperty(_mapTencentDocMimeTyp, MimeType.Pdf, TencentDocExt.PDF), _defineProperty(_mapTencentDocMimeTyp, MimeType.SmartCanvas, TencentDocExt.SmartCanvas), _defineProperty(_mapTencentDocMimeTyp, MimeType.SmartSheet, TencentDocExt.SmartSheet), _defineProperty(_mapTencentDocMimeTyp, MimeType.Mind, TencentDocExt.ProcessOnMindMap), _defineProperty(_mapTencentDocMimeTyp, MimeType.FlowChart, TencentDocExt.ProcessOnFlowChart), _defineProperty(_mapTencentDocMimeTyp, MimeType.Rec, TencentDocExt.SogouSpeech), _defineProperty(_mapTencentDocMimeTyp, MimeType.Board, TencentDocExt.Board), _defineProperty(_mapTencentDocMimeTyp, MimeType.Markdown, TencentDocExt.Markdown), _mapTencentDocMimeTyp);
function timestamp(input) {
  return Math.floor(Number(input) / 1000);
}
function notSupportPin(folderId) {
  // 用来判断该列表是否支持置顶功能，可扩展
  // 当不支持置顶功能时，需要将isPinned设置为null，就不会刷新原有node节点的isPinned状态了
  if (folderId === RECENT_FOLDER_ID) return true;
  return false;
}
//# sourceMappingURL=file-list.js.map